
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/game/[id]",
      function () {
        return require("private-next-pages/game/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/game/[id]"])
      });
    }
  